import TriangleDividerVertical from "../../components/triangle/triangle-divider-vertical"
import useMediaQueries from '../../hooks/useMediaQueries'
import authInfinite from "../../assets/icons/auth-infinite.svg"
import BrandLogo from "../../components/brand-logo";
// import { useLayoutEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { confirmGuestLoginRequest, confirmMessageRequest, userLogin } from "../../assets/api/userActions";
import './index.scss'
import { useEffect } from "react";

const GuestConfirm = () => {

    const params = useParams();
    const navigate = useNavigate();

    // const paramsName = searchParams.get("name");


    const [loginPhone, setLoginPhone] = useState("");
    const [loginName, setLoginName] = useState("");
    const [loginCode, setLoginCode] = useState("");

    const { isAbove922 } = useMediaQueries();

    useEffect(() => {
        let ssData = JSON.parse(sessionStorage.getItem("guestInfo"))
        setLoginPhone(ssData.phone)
        setLoginName(ssData.name)
        // sessionStorage.clear();
        // console.log(ssData);
    }, [])

    function onGoBackHandler() {
        navigate(`/auth/login/guest/${params.code}`);
    }

    function showResendResult(res) {
        if (res.returnCode === "SUCCESS") {
            Swal.fire({
                icon: "success",
                title: "کد تایید با موفقیت ارسال شد",
                timer: 2000

            })
        }
    }

    function resHandler(res) {
        if (res.returnCode === "SUCCESS") {
            const today = new Date();
            let tomorrow = new Date();
            const setExpireDate = tomorrow.setDate(today.getDate() + 1);
            const { token, ...newUserData } = res;
            // console.log(quizToken);
            localStorage.setItem("userToken", JSON.stringify({
                ...newUserData, userToken: token, "expireDate": setExpireDate
            }))
            navigate("/quiz/join/" + params.code)
        }
    }

    async function onResendCode() {
        if (!minutes && !seconds) {
            await confirmGuestLoginRequest(loginName, loginPhone, params.code).then(res => showResendResult(res));
        }
    }

    const initialMinute = 2, initialSeconds = 0
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] = useState(initialSeconds);
    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    }, [minutes, seconds]);

    const onSubmitHandler = async (e) => {
        e.preventDefault();

        if (!loginCode.length) {
            Swal.fire({
                icon: "error",
                title: "شماره خود را وارد کنید",
                confirmButtonText: "باشه"
            })
            return;
        }

        else {
            await confirmGuestLoginRequest({
                name: loginName,
                phone: loginPhone,
                code: loginCode,
                quizCode: params.code
            }
            ).then(res => resHandler(res));
            // const today = new Date();
            // let tomorrow = new Date();
            // const setExpireDate = tomorrow.setDate(today.getDate() + 1);
            // const { token, ...newUserData } = userData;
            // localStorage.setItem("userToken", JSON.stringify({
            //     ...newUserData, userToken: token, "expireDate": setExpireDate
            // }))
        }

    }

    function renderSvgBox() {
        if (isAbove922) {
            return (
                <div className="auth-page__svg-box">
                    <object
                        type="image/svg+xml"
                        data={authInfinite}
                        width="523"
                        height="308"
                    >
                        عکس متحرک
                    </object>
                    <BrandLogo width="128" height="39" className="auth-page__brand-logo" />
                </div>
            );
        }
    }

    return (
        <main className="auth-page">
            {renderSvgBox()}
            <section className="auth-page__content">
                <TriangleDividerVertical />
                <div className="auth-page__form-container">
                    <div className="auth-page--center">

                        <form
                            onSubmit={onSubmitHandler}
                            className="form-login"
                        >
                            <h4 className="login-title">ورود به صورت مهمان</h4>
                            <p className="login-description">کد ارسال شده به شماره {loginPhone} را وارد کنید</p>
                            <div className="d-flex">
                                <input
                                    type="number"
                                    className="input-style"
                                    placeholder="کد ارسال شده"
                                    onChange={(e) => {
                                        setLoginCode(e.target.value);
                                    }}
                                />
                                <div className="login-countdown">
                                    {minutes === 0 && seconds === 0
                                        ? null
                                        : <h1> {minutes}:{seconds < 10 ? `0${seconds}` : seconds}</h1>
                                    }
                                </div>
                            </div>
                            <div className="d-flex">
                                <p className="link-login" style={{ padding: "0 25px" }} onClick={() => onResendCode()}>ارسال مجدد کد</p>
                                <p className="link-login" style={{ padding: "0 25px" }} onClick={() => onGoBackHandler()}>تصحیح شماره</p>
                            </div>
                            <button
                                type="submit"
                                className="button-login"
                            >
                                ورود
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default GuestConfirm